// extracted by mini-css-extract-plugin
export default {"footerContainer":"style_footerContainer__rG35g","priceContainer":"style_priceContainer__sXYvV"};